import React from "react";
import { Navigate, useLocation } from "react-router-dom";

function isTokenValido() {
  const token = localStorage.getItem("token");
  const tokenData = JSON.parse(localStorage.getItem("tokenData"));
  if (!token || !tokenData) return false;
  return Date.now() < tokenData.expiraEm;
}

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const tipo = localStorage.getItem("usuarioTipo"); // "cliente" ou "colaborador"

  if (!isTokenValido()) {
    return <Navigate to="/" replace />;
  }

  // === Verifica tipo e rota ===
  const path = location.pathname;

  const isColaboradorPath = path.startsWith("/area-restrita/colaborador");
  const isClientePath = path.startsWith("/area-restrita");

  if (tipo === "colaborador" && !isColaboradorPath) {
    // colaborador acessando rota de cliente
    const newPath = path.replace("/area-restrita", "/area-restrita/colaborador");
    return <Navigate to={newPath} replace />;
  }

  if (tipo === "cliente" && isColaboradorPath) {
    // cliente acessando rota de colaborador
    const newPath = path.replace("/area-restrita/colaborador", "/area-restrita");
    return <Navigate to={newPath} replace />;
  }

  return children;
}
